import { useMemo } from 'react';

import { useCageActiveFishGroupController_getActiveFishGroup } from '@/services/hooks';
import type { CageActiveFishGroupResponseDto } from '@/services/types';

import type { DomainQueryOptions, QueryResult } from '../shared/types';

import type { CageActiveFishGroup } from './types';

/** The fish group in the cage now, or `null` when the cage is empty. */
export const useGetCageActiveFishGroup = (
    cageId: number,
    options?: DomainQueryOptions<CageActiveFishGroupResponseDto>
): QueryResult<CageActiveFishGroup | null> => {
    const query = useCageActiveFishGroupController_getActiveFishGroup(cageId, options);

    const activeFishGroup = useMemo((): CageActiveFishGroup | null => {
        const dto = query.data?.data?.activeFishGroup;
        if (!dto) return null;
        return {
            id: dto.id,
            name: dto.name,
            // The generator turns the nullable column into an optional field.
            initialPopulationSize: dto.initialPopulationSize ?? null,
        };
    }, [query.data?.data]);

    return {
        data: activeFishGroup,
        isLoading: query.isPending,
        isFetching: query.isFetching,
        isFetched: query.isFetched,
        error: query.error,
        refetch: query.refetch,
    };
};
